import { NavigationLinkProps } from "client/Components";
import { outOfContextCallError } from "client/Misc/reactUtils";
import {
	ReactElement,
	Ref,
	createContext
} from "react";

export type NavigationLinkContextData = {
	render(props: NavigationLinkProps, ref: Ref<HTMLAnchorElement>): ReactElement;
};

export const NavigationLinkContext = createContext<NavigationLinkContextData>({
	render: outOfContextCallError("NavigationLinkContext", "render")
});